import { Navigate, useParams } from 'react-router-dom';

// Old emailed "View Quote" links: never show a quote from the URL alone, go through portal sign-in with the quote remembered
export default function LegacyQuoteLink() {
  const { quoteId } = useParams();
  return <Navigate to={`/customer-portal?quote=${encodeURIComponent(quoteId || '')}`} replace />;
}
